import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdpmServicesService {

  constructor(
    private http: HttpClient
  ) {
    console.log("ADPM SERVICES SERVICES");
  }
}
